import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabContent", "tabLink", "requiredField"]

  connect() {
    // Show the tab based on the URL hash
    if (window.location.hash) {
      const hashId = window.location.hash.substring(1)
      this.tabLinkTargets.forEach(tab => {
        const controlledIds = this._getControlledIds(tab)
        controlledIds.includes(hashId) ? tab.click() : ""
      })
    }
  }

  change(e) {
    // Prevent clicks on tabs (e.g., inside dropdowns) from bubbling up and closing the menu
    // when Bootstrap's auto-close is enabled.
    e.stopPropagation()
    const el = e.currentTarget
    const controlledIds = this._getControlledIds(el)

    // Hide all
    this._hideAll(this.tabLinkTargets, this.tabContentTargets)

    // Then show selected
    el.setAttribute("aria-selected", "true")

    // Show all controlled targets
    const targets = controlledIds.map(id => document.getElementById(id)).filter(Boolean)
    targets.forEach(target => {
      target.removeAttribute("aria-hidden")
    })

    // Set required fields for visible tabs only
    this.requiredFieldTargets.forEach(element => {
      element.removeAttribute('required')

      // Check if element is contained within any of the visible targets
      const isInVisibleTab = targets.some(target => target.contains(element))
      if (isInVisibleTab) {
        element.setAttribute('required', true)
      }
    })
  }

  _hideAll(triggers, targets) {
    triggers.forEach(element => {
      element.setAttribute("aria-selected", "false")
    })

    targets.forEach(element => {
      element.setAttribute("aria-hidden", "true")
    })
  }

  _getControlledIds(element) {
    const ariaControls = element.getAttribute("aria-controls")
    if (!ariaControls) return []

    // Split on whitespace and filter out empty strings
    return ariaControls.trim().split(/\s+/).filter(id => id.length > 0)
  }
}
